module.exports = __webpack_public_path__ + "img/sintomas estrangulamento.d3ff48e2.webp";